/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Boiler_Warning_4Inputs */



/**
* | output |
* | --- |
* | "Without feedback from the physical switch and without run feedback, the displayed theoretical state matches the controller command" |
*
* @param {Boiler_Warning_4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const boiler_warning_4 = /** @type {((inputs?: Boiler_Warning_4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Boiler_Warning_4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Without feedback from the physical switch and without run feedback, the displayed theoretical state matches the controller command")
	return /** @type {LocalizedString} */ ("En l’absence de retour du commutateur physique et de retour de marche, l’état théorique affiché correspond à la commande de l’automate")
});